(function () {
  'use strict';

  var MOBILE_MAX = 1023;
  var resizeTimer;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function isLayoutChild(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('double-wrapper')) return false;

    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isFullWidthItem(el) {
    return (
      el.classList.contains('hp-mob-big') ||
      el.classList.contains('hp-mob-boundary-fix') ||
      el.classList.contains('collection-media-break')
    );
  }

  function getGridParity(grid) {
    var col = 0;

    Array.from(grid.children).forEach(function (child) {
      if (!isLayoutChild(child)) return;

      if (child.matches('product-card')) {
        if (isFullWidthItem(child)) {
          col = 0;
        } else {
          col = (col + 1) % 2;
        }
        return;
      }

      if (child.classList.contains('collection-media-break')) {
        col = 0;
      }
    });

    return col;
  }

  function findLastHalfWidthCard(grid) {
    var children = Array.from(grid.children);

    for (var i = children.length - 1; i >= 0; i--) {
      var child = children[i];
      if (!isLayoutChild(child)) continue;
      if (!child.matches('product-card')) continue;
      if (isFullWidthItem(child)) continue;
      return child;
    }

    return null;
  }

  function clearBoundaryFix(grid) {
    grid.querySelectorAll('.hp-mob-boundary-fix').forEach(function (card) {
      card.classList.remove('hp-mob-boundary-fix');
    });
  }

  function fixMobileGridParity(grid) {
    if (!grid || grid.getAttribute('data-double-display') !== 'true') return;
    if (!isMobile()) {
      clearBoundaryFix(grid);
      return;
    }

    clearBoundaryFix(grid);

    if (getGridParity(grid) !== 1) return;

    var orphan = findLastHalfWidthCard(grid);
    if (!orphan) return;

    orphan.classList.add('hp-mob-boundary-fix');
  }

  function run() {
    var grid = document.getElementById('product-card-container') || document.querySelector('.product-card-list[data-double-display="true"]');
    if (!grid) return;
    fixMobileGridParity(grid);
  }

  window.HPFixMobileGridParity = {
    run: run,
    clear: function (grid) {
      if (grid) clearBoundaryFix(grid);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 200);
  }, { passive: true });

  document.addEventListener('infiniteScrollLoaded', function () {
    var grid = document.getElementById('product-card-container') || document.querySelector('.product-card-list[data-double-display="true"]');
    if (grid) clearBoundaryFix(grid);
    run();
  });
})();
